import * as React from 'react';

import { ChoicePopUp } from '../ChoicePopup';
import { HouseIcon } from './icons/HouseIcon';
import { HouseLargeIcon } from './icons/HouseLargeIcon';
import * as styles from './ReliableChoicePopup.css';

export interface IReliableChoicePopupProps {
  url: string;
}

export const ReliableChoicePopup: React.FC<IReliableChoicePopupProps> = ({ url }) => {
  return (
    <ChoicePopUp
      icon={<HouseLargeIcon />}
      description="В ЖК есть корпуса, проверенные ЦИАН."
      title="Проверено ЦИАН"
      url={url}
    >
      <span className={styles['icon']}>
        <HouseIcon />
      </span>
    </ChoicePopUp>
  );
};
